import cx from "classnames";
import {
  modalStateValues,
  PREMIUM_JOB,
  premiumPopupsTypes
} from "../../services/constants";
import useModalStore from "../../zustandStores/useModalStore";
import useCreditProfileStore from "../../zustandStores/userCreditProfileStore";
import CustomButtonWrapper from "../CustomButtonWrapper";
import classes from "./upgrade.module.css";
import LogService from "../../services/LogService";
import CREDIT_EVENTS from "../../utils/CreditEvents";
import CreditBar from "../CreditBar";
import { getIsSufficientCredits } from "../../utils/creditUtils";
import UpgradePremium from "../../Tailwind/components/local/UpgradePremium";
import { JhButton } from "designPackages/buttonPackage";
import { JhText } from "designPackages/textPackage";
import { Gem } from "lucide-react";
import { RESPONSE_MANAGER_V3 } from "constants/responseManagerV3Constants";

function UpgradeToPremiumCTA({ onClickHandler, item, hideSubTag, view, page }) {
  const { setModalData } = useModalStore(state => ({
    modalData: state.modalData,
    setModalData: state.setModalData
  }));
  const { isCreditBetaUser } = useCreditProfileStore(state => ({
    isCreditBetaUser: state.isCreditBetaUser,
    data: state.data
  }));
  const isView2 = view === "view-2";
  const info = { jobId: item.job_id, page: page };

  const buyNow = () => {
    setModalData({
      type: "",
      state: modalStateValues.CLOSE
    });
    if (isView2) {
      LogService.log(CREDIT_EVENTS.COHORT_IN_SUFF_BUY_CREDITS, info);
    } else {
      LogService.log(CREDIT_EVENTS.UPGRADE_IN_SUFF_BUY_CREDITS, info);
    }
  };

  const onPopupConfirm = response => {
    setModalData({
      type: premiumPopupsTypes.upgradeJob,
      state: modalStateValues.CLOSE
    });
    if (isView2) {
      LogService.log(CREDIT_EVENTS.COHORT_SUFFI_CREDIT_LANDED_CONFIRM, info);
    } else {
      LogService.log(CREDIT_EVENTS.UPGRADE_SUFFI_CREDIT_LANDED_CONFIRM, info);
    }

    onClickHandler(response);
  };

  const onModalClose = async () => {
    const isSufficientCredits = await getIsSufficientCredits({
      jobId: item.job_id
    });

    if (isSufficientCredits) {
      if (isView2) {
        LogService.log(CREDIT_EVENTS.COHORT_SUFF_CREDIT_DISMISS, info);
        return;
      }
      LogService.log(CREDIT_EVENTS.UPGRADE_SUFF_CREDIT_DISMISS, info);
      return;
    }

    if (isView2) {
      LogService.log(CREDIT_EVENTS.COHORT_IN_SUFF_CREDIT_DISMISS, info);
      return;
    }
    LogService.log(CREDIT_EVENTS.UPGRADE_IN_SUFF_CREDIT_DISMISS, info);
  };

  const onJobUpgradeSuccess = (isSufficientCredits, upgradeApiResponse) => {
    if (isSufficientCredits) {
      onPopupConfirm(upgradeApiResponse);
    } else {
      buyNow();
    }
  };

  const onPopupMount = isSufficientCredits => {
    if (!isSufficientCredits) {
      if (isView2) {
        LogService.log(CREDIT_EVENTS.COHORT_LIMIT_INSUFF_CREDIT_LANDED, info);
      } else {
        LogService.log(CREDIT_EVENTS.UPGRADE_LIMIT_INSUFF_CREDIT_LANDED, info);
      }
    } else {
      if (isView2) {
        LogService.log(
          CREDIT_EVENTS.COHORT_LIMIT_SUFFICIENT_CREDIT_LANDED,
          info
        );
      } else {
        LogService.log(CREDIT_EVENTS.UPGRADE_SUFFICIENT_CREDIT_LANDED, info);
      }
    }
  };

  const onUpgradeClick = async () => {
    const isSufficientCredits = await getIsSufficientCredits({
      jobId: item.job_id
    });
    onPopupMount(isSufficientCredits);
    if (isView2) {
      LogService.log(CREDIT_EVENTS.COHORT_LIMIT_VIEW_CANDIDATES_CLICK, info);
    } else {
      LogService.log(CREDIT_EVENTS.DASHBOARD_UPGRADE_TO_PREMIUM_CLICK, info);
    }
    const candidatesLockedHeading =
      "Upgrade this job to premium and view all candidates.";

    setModalData({
      type: premiumPopupsTypes.upgradeJob,
      state: modalStateValues.open,
      heading: isView2 ? candidatesLockedHeading : null,
      jobId: item.job_id,
      callback: onJobUpgradeSuccess,
      closeCallback: onModalClose
    });
  };

  if (
    !isCreditBetaUser ||
    item?.jobPlan === PREMIUM_JOB ||
    item?.jobPlan === "PREMIUM" ||
    item.status !== "LIVE"
  ) {
    return null;
  }

  if (view === "view3") {
    return (
      <span
        id="upgrade_visibility"
        className={classes.boostMessageBtn}
        onClick={onUpgradeClick}
      >
        Upgrade to Premium
      </span>
    );
  }

  if (view === "view-4") {
    return (
      <CreditBar
        view={"view1"}
        onBtnClickView1={onUpgradeClick}
        view1DesktopMessage1="Need more direct applies?"
        view1DesktopMessage2="Upgrade now to get boosted visibility"
        view1MobileMessage1="Need more direct applies?"
        info={"CMP"}
      />
    );
  }

  if (view === "view-5") {
    return <CreditBar view={"view2"} onBtnClickView2={onUpgradeClick} />;
  }
  if (view === "view-db") {
    return <UpgradePremium onUpgradeClick={onUpgradeClick} />;
  }

  if (view === "view-6") {
    return (
      <JhButton
        size="xs"
        variant="outline"
        className={classes.upBtn}
        onClick={onUpgradeClick}
      >
        <div className="flex items-center gap-1">
          <img src="/hire/premium_tag.svg" alt="premium" />
          <JhText
            color="discovery-foreground"
            className="hidden md:block"
            variant="caption1"
          >
            Upgrade to Premium
          </JhText>
          <JhText
            color="discovery-foreground"
            className="block md:hidden"
            variant="caption1"
          >
            Upgrade
          </JhText>
        </div>
      </JhButton>
    );
  }
  if (view === "view-7") {
    return (
      <JhButton
        size="xs"
        variant="outline"
        onClick={onUpgradeClick}
        className="w-full flex items-center justify-center"
      >
        <Gem size={16} className="mr-1" />
        Upgrade
      </JhButton>
    );
  }
  if (view === RESPONSE_MANAGER_V3) {
    return (
      <JhButton
        size="xs"
        variant="outline"
        onClick={onUpgradeClick}
        className="w-full flex items-center justify-center rounded-2xl gap-1 text-foreground py-2 px-4"
      >
        <Gem size={16} className="text-foreground" />
        <JhText variant="subtitle4">Upgrade</JhText>
      </JhButton>
    );
  }
  return (
    <>
      {view === "view-2" ? (
        <CustomButtonWrapper
          customClass={cx(classes.btnClass)}
          iconUrl="/hire/lock.svg"
          content={"View All Candidates"}
          onClick={onUpgradeClick}
          alignIcon="right"
        />
      ) : (
        <>
          <div onClick={onUpgradeClick} className={classes.upgradeBtn}>
            Upgrade to Premium
          </div>
          <div className={classes.container}>
            <CustomButtonWrapper
              customClass={cx(classes.btnClass, classes.gapRight)}
              variant="outlined"
              iconUrl="/hire/upgrade_icon.svg"
              content={"Upgrade to Premium"}
              onClick={onUpgradeClick}
            >
              Upgrade to Premium
            </CustomButtonWrapper>
            {!hideSubTag && (
              <div className={classes.tag}>FOR FASTER HIRING</div>
            )}
          </div>
        </>
      )}
    </>
  );
}

export default UpgradeToPremiumCTA;
